import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Attention } from '../interfaces/attention';
import { Invite } from '../interfaces/invite';
import { DatabaseRecord } from '../mixins/database-record';
import { ActivityLog, HasActivityLogs } from '../mixins/has-activity-logs';
import { AgencyBlocAddress, HasAgencyBlocAddresses } from './agency-bloc-address';
import { AgencyBlocCustomField } from './agency-bloc-custom-field';
import { AgencyBlocEntity } from './agency-bloc-entities';
import { AgencyBlocPolicy } from './agency-bloc-policy';
import { HasEmailAttribute, HasFullNameAttribute } from './search-results-record';
import { User } from './user';

export class AgencyBlocIndividual extends DatabaseRecord(AgencyBlocCustomField(HasAgencyBlocAddresses(HasActivityLogs(AgencyBlocEntity(HasEmailAttribute(HasFullNameAttribute())))))) {
  public readonly $entityID = 'individualID';
  public readonly $entityType = 'Individual';
  public readonly $entityDateLabel = 'DOB';

  public partner?: AgencyBlocIndividual;
  public individualID = 0;
  public firstName = '';
  public middleInitial = '';
  public lastName = '';
  public nickName = '';
  public birthDate = new Date();
  public gender = '';
  public ssn = '';
  public medicareID?: number;
  public title = '';
  public servicingAgentName = '';
  public leadSource = '';
  public leadSourceOther = '';
  public leadSourceAgentName = '';
  public leadDate?: Date;
  public projectCode = '';
  public status = '';
  public type = '';
  public groupID = 0;
  public externalID = '';
  public homePhone = '';
  public homePhoneExt = '';
  public businessPhone = '';
  public businessPhoneExt = '';
  public cellPhone = '';
  public cellPhoneExt = '';
  public entityID = 0;
  public driversLicenseNum = '';
  public deceasedDate = '';
  public medicareBeneficiaryID = '';
  public medicareEffectiveDatePartA = '';
  public medicareEffectiveDatePartB = '';
  public smokerStatus = '';
  public addresses: AgencyBlocAddress[] = [];
  public meetings: {
    Name: string;
    Value: string;
    date: Date;
  }[] = [];
  public user?: User;
  public invite?: Invite;
  public attention?: Attention;
  public group_info?: {
    groupID: number;
    groupName: string;
    type: string;
    dba: string;
  };
  /**
   * Used with OurGoals to track the completion of meetings during the various stages of the process.
   */
  public completed_meetings: {
    education: boolean; // this.getCustomFieldValue('Education Mtg (Status)') === 'Completed',
    solution: boolean; // this.getCustomFieldValue('Solution Mtg (Status)') === 'Completed',
    application: boolean; // !!this.policy.AppSubmitDate
    approval: boolean; // !!this.policy.EffectiveDate
    placed: boolean; // !!this.policy.getCustomFieldValue('Placement Date')
  } = {
    education: false,
    solution: false,
    application: false,
    approval: false,
    placed: false,
  };

  /**
   * Whether this individual is the lead partner in a couple.
   */
  public lead_partner: boolean = false;

  /**
   * The Policy associated with this individual.
   */
  public policy?: AgencyBlocPolicy;

  /**
   * Get the entity date for this Model. Usually used for sorting and displaying in the UI.
   */
  public get entityDate(): Date {
    return new Date(this.birthDate);
  }

  /**
   * Get the entity ID for this Model. Usually used for sorting and displaying in the UI.
   */
  public get entityId(): number {
    return this.individualID;
  }

  constructor(data?: AgencyBlocIndividual) {
    super(data);
    Object.assign(this, data);

    if (data) {
      if (this.created_at) this.created_at = new Date(this.created_at);
      if (this.updated_at) this.updated_at = new Date(this.updated_at);
      if (this.deleted_at) this.deleted_at = new Date(this.deleted_at);
      if (this.birthDate) this.birthDate = new Date(this.birthDate);
      if (this.logs) this.logs = this.logs.map((log) => new ActivityLog(log));
    }
  }

  public createFormGroup(): FormGroup {
    const group = super.createFormGroup();

    group.patchValue({
      individualID: new FormControl(this.individualID, [Validators.required]),
      firstName: new FormControl(this.firstName, []),
      middleInitial: new FormControl(this.middleInitial, []),
      lastName: new FormControl(this.lastName, []),
      email: new FormControl(this.email, [Validators.required, Validators.email]),
      title: new FormControl(this.title, [Validators.required]),
      leadDate: new FormControl(this.leadDate, [Validators.required]),
      status: new FormControl(this.status, [Validators.required]),
      type: new FormControl(this.type, [Validators.required]),
      projectCode: new FormControl(this.projectCode, [Validators.required]),
    });

    return group;
  }
}
